/* eslint-disable jsx-a11y/media-has-caption */
import React, { CSSProperties, useState } from 'react';
import { Fab, Icon, makeStyles, Theme } from '@material-ui/core';
import { VideoInfo } from '@moderepo/mode-apis';
import clsx from 'clsx';


const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
        },

        eventVideosWrapper: {
            position: 'relative',
            overflow: 'hidden',
        },

        eventVideosSlider: {
            display       : 'flex',
            whiteSpace    : 'nowrap',
            alignItems    : 'center',
            justifyContent: 'flex-start',
            transition    : 'transform ease-out 200ms',
        },

        eventVideo: {
            zIndex   : 1,
            display  : 'block',
            width    : '100%',
            objectFit: 'cover',
        },

        videoScrollButton: {
            position : 'absolute',
            top      : '50%',
            transform: 'translateY(-50%)',
            zIndex   : 2,

            '&.prev': {
                left: theme.spacing(1),
            },
            '&.next': {
                right: theme.spacing(1),
            },
        },
    };
}, { name: 'VideosScroller', index: 1 });



export interface VideosScrollerProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly videos?: readonly VideoInfo[] | undefined;
    readonly noDataMessageComp?: React.ReactNode | undefined;
}


/**
 * Given an Array of videos, this component shows the videos and provide the < > buttons for the user to scroll through the videos.
 */
export const VideosScroller: React.FC<VideosScrollerProps> = (props: VideosScrollerProps) => {

    const classes = useStyle();
    const [currentVideo, setCurrentVideo] = useState<number>(0);

    return (
        <div
            className={clsx(props.className, classes.root)}
            style={props.style}
        >
            {props.videos && props.videos.length > 0 ? (
                <div
                    className={classes.eventVideosWrapper}
                >
                    {/* Show the prev/next button if there are more than 1 videos */}
                    {props.videos.length > 1 && (
                        <Fab
                            className={clsx(classes.videoScrollButton, 'prev')}
                            disabled={currentVideo <= 0}
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation();
                                setCurrentVideo((currentVideo) => {
                                    return currentVideo - 1;
                                });
                            }}
                        >
                            <Icon>chevron_left</Icon>
                        </Fab>
                    )}

                    <div
                        className={classes.eventVideosSlider}
                        style={{
                            transform: `translateX(${currentVideo * -100}%)`,
                        }}
                    >
                        {props.videos.map((eventVideo) => {
                            return (
                                <video
                                    key={eventVideo.thumbnail}
                                    className={classes.eventVideo}
                                    controls={true}
                                    preload="metadata"
                                    poster={eventVideo.thumbnail}
                                >
                                    <source src={eventVideo.video} />
                                </video>
                            );
                        })}
                    </div>

                    {/* Show the prev/next button if there are more than 1 videos */}
                    {props.videos.length > 1 && (
                        <Fab
                            className={clsx(classes.videoScrollButton, 'next')}
                            disabled={currentVideo >= props.videos.length - 1}
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation();
                                setCurrentVideo((currentVideo) => {
                                    return currentVideo + 1;
                                });
                            }}
                        >
                            <Icon>chevron_right</Icon>
                        </Fab>
                    )}
                </div>
            ) : (
                props.noDataMessageComp
            )}
        </div>
    );
};
